import React from "react";
import { NavLink } from "react-router-dom/cjs/react-router-dom";

const NavBar=(props)=>{
  const handleClick = () => {
    props.contactref.current?.scrollIntoView({behavior: 'smooth'});
      };
      const handleServiceClick = () => {
        props.serviceref.current?.scrollIntoView({behavior: 'smooth'});
          };
    return(
        <>

        <div className="container-fluid nav_bg  rder  ">
            <div className="row bk " >
                <div className="col-10 mx-auto">

        
            <nav className="navbar navbar-expand-lg navbar-light text-white ">
  <div className="container-fluid text-white">
    <NavLink  className="navbar-brand text-white" to="/">Baig Tech</NavLink>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse text-white " id="navbarSupportedContent">
      <ul className="navbar-nav ml-auto mb-2  mb-lg-0">
        <li className="nav-item text-white">
          <NavLink activeClassName="menu_active" exact className="nav-link active text-white" aria-current="page" to=
    "/">Home</NavLink>
        </li>
     
        <li className="nav-item">
          <NavLink  activeClassName="menu_active" className="nav-link text-white" onClick={handleServiceClick} to=
    "/service">services</NavLink>
        </li>

        <li className="nav-item">
          <NavLink activeClassName="menu_active" className="nav-link text-white" onClick={handleClick} to=
    "/con">Contact</NavLink>
        </li>

       
        
       
      </ul>
      
    </div>
  </div>
</nav>
        </div>
            </div>
        </div>
        </>
    )
}

export default NavBar